import { capitalizeIfLower } from '@btime/helpers'
import { compose, last, prop, sortBy } from 'ramda'

export const getReason = serviceOrder => {
  const { statusReason, events } = serviceOrder || {}
  const isUsingStatusReason = !!statusReason
  const lastEvent = getLastEvent(events)
  const description = isUsingStatusReason ? statusReason?.description : lastEvent?.description
  const minicrudName = capitalizeIfLower(isUsingStatusReason ? statusReason?.name : lastEvent?.reason?.name)
  const document = isUsingStatusReason ? statusReason?.document : lastEvent?.document
  const documents = isUsingStatusReason ? statusReason?.documents : lastEvent?.documents

  if (!minicrudName) return null

  return {
    description,
    minicrudName,
    document,
    documents
  }
}

export const getLastEvent = events => compose(last, sortBy(prop('eventDate')))(events || [])
